const postCancelHelpRequestPayload = (payload) => {
  return { helpRequestId: payload?.helpRequestId };
};

export default postCancelHelpRequestPayload;
